(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("video", [], factory);
	else if(typeof exports === 'object')
		exports["video"] = factory();
	else
		root["video"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 